export var BaseDict = {
    NoMarketsAvailable: "No markets Available"
};
//# sourceMappingURL=dict.js.map